<template>
  <div class="form-container elevation-1">
    <v-form @submit.prevent="confirmClicked">
      <v-layout justify-end>
        <Logo class="ts-logo"/>
        <div class="ts-logo">
          ThinkSpatial
        </div>
      </v-layout>
      <h2 class="display-3">New Password</h2>
      <div class="form-region">
        <v-text-field label="Password *" type="password" hint="Your password must ONLY contain the letters a to z in either upper or lowercase, and the numbers 0 to 9." v-model="password" :rules="[rules.required, rules.passwordValidity]" :validate-on-blur=true></v-text-field>
        <v-text-field label="Confirm password *" type="password" v-model="confirm" hint="Should match your above password, this detects typos." :rules=[rules.required]></v-text-field>
      </div>
      <a class="blockify text-center" href="mailto:support@thinkspatial.com.au">Having trouble? Please contact ThinkSpatial Support directly.</a>
      <v-layout justify-end>
        <v-btn v-if="!sending" class="blockify" dark type="submit" variant="primary" color="#e7511e" >Confirm</v-btn>
        <ball-scale-loader v-if="sending" color="#1976d2"/>
      </v-layout>
    </v-form>
  </div>
</template>
<script>
import Logo from 'assets/svg/ts-logo-only.svg';
import { BallScaleLoader } from 'vue-loaders';
import CommonRules from 'src/common-rules.js';
import Authentication from '@/services/AuthenticationApi';
export default {
  components: {
    Logo,
    BallScaleLoader,
  },
  created: () => {
    document.title = 'ThinkSpatial | New Password';
  },
  data() {
    return {
      error: null,
      sending: false,
      resetCode: null,
      password: null,
      confirm: null,
      rules: CommonRules
    }
  },
  methods: {
    async confirmClicked () {
      try {    
        if (!this.resetCode) {
          this.$swal({
            title: 'Oops!',
            text: 'Reset code is invalid. Please follow the link from your reset email again.',
            type: 'error'
          });
          return;
        }

        if (!this.confirm || this.confirm !== this.password) {
          this.$swal({
            title: 'Oops!',
            text: 'Your password confirmation did not match your password.',
            type: 'error'
          });
          return;
        }

        const response = await Authentication.resetpassword({
          resetToken: this.resetCode,
          password: this.password
        })
        this.$swal({
          title: 'Success!',
          text: response.data.message,
          type: 'success'
        })
        .then(()=>{
          this.$router.push({
            name: 'default'
          })
        });
      } catch(err) {
        if(err.response) {
          this.$swal({
            title: 'Oops!',
            text: err.response.data.error,
            type: 'error'
          })
          .then(()=>{
            if(err.response.data.error.indexOf("Reset") >= 0) {
              this.$router.push({
                name: 'forgotpassword'
              })
            }
          });
        } else {
          console.log(err)
        }
        
      }
    }
  },
  async mounted () {
    try {
      this.resetCode = this.$store.state.route.query.reset;
    } catch (err) {
      console.log(err)
      this.resetCode = null;
    }
  }   
}
</script>
<style lang="scss" scoped>
  @import 'assets/landing.scss';
</style>
